<template>
  <section class="card_style">
    <form @submit.prevent="editSesrvice">
      <div class="main_service">
        <h4 v-if="$route.params.id">{{ $t("Edit Service") }}</h4>
        <h4 v-else>{{ $t("Add Service") }}</h4>
      </div>

      <div class="row">
        <!-- Title AR -->
        <div class="col-6">
          <div class="form-group">
            <label class="form-label" for="Service_title_ar">{{
              $t("Service_title_ar")
            }}</label>
            <input
              type="text"
              class="form-control"
              id="Service_title_ar"
              v-model="Service_title_ar"
            />
          </div>
        </div>

        <!-- Title EN -->
        <div class="col-6">
          <div class="form-group">
            <label class="form-label" for="Serivce_title_en">{{
              $t("Serivce_title_en")
            }}</label>
            <input
              type="text"
              class="form-control"
              id="Serivce_title_en"
              v-model="Serivce_title_en"
            />
          </div>
        </div>

        <!-- Subtitle AR -->
        <div class="col-6">
          <div class="form-group">
            <label class="form-label" for="Service_subtitle_ar">{{
              $t("Service_subtitle_ar")
            }}</label>
            <input
              type="text"
              class="form-control"
              id="Service_subtitle_ar"
              v-model="Service_subtitle_ar"
            />
          </div>
        </div>

        <!-- Subtitle EN -->
        <div class="col-6">
          <div class="form-group">
            <label class="form-label" for="Service_subtitle_en">{{
              $t("Service_subtitle_en")
            }}</label>
            <input
              type="text"
              class="form-control"
              id="Service_subtitle_en"
              v-model="Service_subtitle_en"
            />
          </div>
        </div>

        <!-- Image + Alt -->
        <div class="col-12">
          <div class="form-group">
            <label class="form-label" for="Service_image">{{
              $t("Service_image")
            }}</label>
            <input
              type="file"
              class="form-control"
              id="Service_image"
              accept="image/png, image/gif, image/jpeg, image/jpg"
              @change="onSingleFileChange"
            />
          </div>

          <div class="main-image-container" v-if="singleImage">
            <div class="image-conteiner">
              <img :src="singleImage.preview" class="entry_image" />
              <div class="form-group mx-2">
                <label class="form-label" for="alt-input">alt</label>
                <input
                  class="form-control"
                  id="alt-input"
                  type="text"
                  v-model="singleImage.alt"
                />
              </div>
            </div>
          </div>

          <span class="input-errors" v-if="v$.singleImage?.$error">
            {{ v$.singleImage.$errors[0].$message }}
          </span>
        </div>

        <!-- Save Button -->
        <div class="col-12">
          <button type="submit" class="btn PrimaryButton">
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  name: "ServiceForm",
  data() {
    return {
      v$: useVuelidate(),
      Service_title_ar: "",
      Serivce_title_en: "",
      Service_subtitle_ar: "",
      Service_subtitle_en: "",
      singleImage: null, // صورة واحدة فقط
    };
  },

  validations() {
    return {
      Service_title_ar: { required },
      Serivce_title_en: { required },
      Service_subtitle_ar: { required },
      Service_subtitle_en: { required },
      singleImage: { required },
    };
  },

  methods: {
    onSingleFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;
      if (!file.type.match("image.*")) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        this.singleImage = {
          file,
          preview: e.target.result,
          alt: "",
        };
      };
      reader.readAsDataURL(file);
    },

    FetchService() {
      let id = this.$route.params.id;
      if (!id) return;

      const formData = new FormData();
      formData.append("service_id", id);

      axios.post(`/show_service`, formData).then(({ data }) => {
        this.Service_title_ar =
          data.data.title.find((t) => t.locale == "ar")?.title || "";
        this.Serivce_title_en =
          data.data.title.find((t) => t.locale == "en")?.title || "";
        this.Service_subtitle_ar =
          data.data.subtitle.find((t) => t.locale == "ar")?.subtitle || "";
        this.Service_subtitle_en =
          data.data.subtitle.find((t) => t.locale == "en")?.subtitle || "";

        if (data.data.image) {
          this.singleImage = {
            file: null,
            preview: data.data.image, // بتيجي من API
            alt: data.data.alt || "",
          };
        }
      });
    },

    editSesrvice() {
      const formData = new FormData();
      let id = this.$route.params.id;
      if (id) formData.append("service_id", id);

      formData.append("title_ar", this.Service_title_ar);
      formData.append("title_en", this.Serivce_title_en);
      formData.append("subtitle_ar", this.Service_subtitle_ar);
      formData.append("subtitle_en", this.Service_subtitle_en);

      if (this.singleImage?.file) {
        formData.append("image", this.singleImage.file);
      }
      formData.append("alt", this.singleImage?.alt || "");

      axios
        .post(id ? `/update_service` : `/add_service`, formData)
        .then(({ data }) => {
          Swal.fire({
            title: "",
            text: data.message,
            icon: "success",
          });
          this.$router.push("/showservice");
        })
        .catch((error) => {
          Swal.fire({
            title: "",
            text: error.response?.data?.message || "Error",
            icon: "error",
          });
        });
    },
  },

  mounted() {
    if (this.$route.params.id) {
      this.FetchService();
    }
  },
};
</script>

<style scoped>
.image-conteiner {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
}
.entry_image {
  max-width: 150px;
  border-radius: 8px;
}
</style>
